
import CloudFun, { defineComponent, ref } from "@cloudfun/core";
import Grid, { GridOptions } from "@/cloudfun/components/Grid.vue";
import { VxeFormProps } from "vxe-table";

export default defineComponent({
  components: {
    Grid,
  },
  setup() {
    const model = CloudFun.current?.model;
    const grid = ref<any>({});

    var printColumns = [
      { field: "Number" },
      { field: "Name" },
      { field: "ContactPerson" },
      { field: "Phone" },
    ];

    const gridOptions: GridOptions = {
      id: "supplier",
      title: "供應商",
      multiselect: false,
      toolbarConfig: { custom: true, refresh: true },
      printConfig: { sheetName: "供應商清單", columns: printColumns, modes: ["current", "selected", "all"] },
      exportConfig: { filename: "供應商清單", type: "csv", types: ["html", "csv"], mode: "all", modes: ["current", "selected", "all"], columns: printColumns },
      columns: [
        { field: 'Number', title: '編號', showHeaderOverflow: true, showOverflow: true, width: 130, sortable: true },
        { field: "Name", title: "名稱", showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: "ContactPerson", title: "聯絡人", showHeaderOverflow: true, showOverflow: true, width: 100, sortable: true },
        { field: 'Phone', title: '聯絡電話', showHeaderOverflow: true, showOverflow: true, width: 100, sortable: true, resizable: false }
      ],
      promises: {
        query: model ? (params) => model.dispatch("supplier/query", params) : undefined,
        queryAll: model ? () => model.dispatch("supplier/query") : undefined,
        save: model ? (params) => model.dispatch("supplier/save", params) : undefined,
      },
      modalConfig: { width: 600, showFooter: true },
    };

    const formOptions: VxeFormProps = {
      titleWidth: 80,
      titleAlign: "right",
      span: 3,
      items: [
        { field: 'Number', title: '編號', span: 12, itemRender: { name: '$input', props: { placeholder: '系統自動產生', disabled: true } } },
        { field: "TaxId", title: "統一編號", span: 12, itemRender: { name: "$input", props: { placeholder: "請輸入統編" } } },
        { field: "Name", title: "名稱", span: 24, itemRender: { name: "$input", props: { placeholder: "請輸入名稱" } } },
        { field: "ContactPerson", title: "聯絡人", span: 12, itemRender: { name: "$input", props: { placeholder: "請輸入姓名" } } },
        { field: "Phone", title: "聯絡電話", span: 12, itemRender: { name: "$input", props: { placeholder: "請輸入電話" } } },
      ],
      rules: {
        Name: [{ required: true }],
        TaxId: [{ message: "統編格式錯誤", pattern: new RegExp("[0-9]{8}") }],
      }
    };

    return {
      grid,
      gridOptions,
      formOptions,
    };
  },
  methods: {
    hideBatchDropDown () {
      cash("#batch-dropdown").dropdown("hide");
    }
  }
});
